import { PortCallsScreen, portCallRoute } from '@felix/ui';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';
import { Shell } from '../components/Shell.js';
import { officePortCallsSource } from '../port-calls-source.js';

/** Operations ▸ Port Calls (ADR 0052): gemide kaydedilir; ofiste salt okunur. */
export function PortCallsPage() {
  const { t } = useTranslation();
  const { search } = useLocation();
  return (
    <Shell title={t('portCalls.list.title')}>
      <PortCallsScreen source={officePortCallsSource} route={portCallRoute(search)} />
    </Shell>
  );
}
